<template>
  <div>
    <!-- Filters -->
    <!--
    <products-list-filters
      :role-filter.sync="roleFilter"
      :plan-filter.sync="planFilter"
      :status-filter.sync="statusFilter"
      :role-options="roleOptions"
      :plan-options="planOptions"
      :status-options="statusOptions"
    />-->

      <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >    
      <div class="m-2">

        <!-- Table Top -->
        <b-row class="justify-content-between align-items-center">

          <!-- Per Page -->
          <b-col
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0" :md="4"
          >
            <label>Gösterim Sayısı</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>sonuç</label>
          </b-col>
          <b-col :md="4" v-if="title">
            <b-card-title class="justify-content-center mb-0 text-center">
              {{ title }}
            </b-card-title>
          </b-col>
          <b-col :md="4" v-if="isFenomen"></b-col>
          <b-col v-else :md="4">
            
            <div class="d-flex align-items-center justify-content-end">
              <!-- İndirme Butonu -->
              <div class="mr-2">
                <button class="btn btn-success"
                  id="popover-reactive-1"
                  ref="button"      
                  :disabled="popoverShow">
                    <feather-icon
                      icon="DownloadIcon"
                      class="mr-50"
                    />
                  <span class="align-middle">{{ popoverShow ? 'Dosya Hazırlanıyor...' : 'Excel Hazırla' }}</span>    
                </button>

                <b-popover
                  ref="popover"
                  target="popover-reactive-1"
                  triggers="click"
                  :show.sync="popoverShow"
                  placement="auto"
                  container="my-container"
                >
                <template #title>
                  <div class="d-flex justify-content-between align-items-center">
                    <span>Excel Hazırla</span>
                  </div>
                </template>
                  <download-excel :excelTitle="title" :additionalParams="additionalParams" v-model="popoverShow" @popoverShow="popoverShow = $event" />
                </b-popover>
              </div>
              <v-select
                v-model="linkFilter"
                :options="linkStatusOption"
                :reduce="val => val.id"
                label="label"
                class="invoice-filter-select custom-vue-select"
                placeholder="Link içi/dışı seç"
              >
              </v-select>
            </div>
          </b-col>

        </b-row>

      </div>
      <b-table
        ref="refProductsListTable"
        class="position-relative"
        :items="productData"
        responsive
        :fields="resolvedTableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Ürün Bulunamadı"
        :sort-desc.sync="isSortDirDesc"
      >
      
      <template #head(inf_payment_total)="data">
        <div class="text-right">{{ data.field.label }}</div>
      </template>

      <template #cell(created_date)="data">
        {{ formatDate(data.item.created_date) }}
      </template>

      <template #cell(in_link_count)="data">
        <div class="d-flex flex-column">
          <span class="text-success" v-if="linkFilter!='out_link'">Link İçi : <b>{{ data.item.in_link_count }} Adet</b></span>
          <span class="text-danger" v-if="linkFilter!='in_link'">Link Dışı : <b>{{ data.item.out_link_count }} Adet</b></span>
        </div>
      </template>
      
      <template #cell(base_price)="data">
        <div>{{ priceFormat(data.item.base_price) }}</div>
      </template>

      <template #cell(name)="product">
          <a :href="$store.state.user.customerInfo.domain+product.item.url" target="_blank">{{ product.item.name }} </a>
      </template>

        
      <template #cell(sale_count)="data">
        <b>{{ data.item.sale_count }}</b> Adet
      </template>

      <template #cell(image)="product">
          <img :src="product.item.image" height="100" />
      </template>

      <template #cell(show_details)="data">

     <!-- As `data.showDetails` is one-way, we call the toggleDetails function on @change -->
      <b-form-checkbox
        v-model="data.detailsShowing"
        @change="data.toggleDetails"
        style="display: none;" 
      >
      </b-form-checkbox>

      <!-- Gizli checkbox'ın tıklama olayını tetikleyecek bir alan -->
      <div @click="data.toggleDetails" style="cursor: pointer;">
        <FeatherIcon icon="ChevronUpIcon" v-if="data.detailsShowing"></FeatherIcon>
        <FeatherIcon icon="ChevronDownIcon" v-else></FeatherIcon>
      </div>
      </template>
    </b-table>
    <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalProducts"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>

  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BCardTitle,
  BBadge, BDropdown, BDropdownItem, BPagination, BFormCheckbox, BTableLite, BPopover
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ref, watch, computed   } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import ProductsListFilters from '@/components/product/ProductsListFilters.vue'
import useProductsList from '@/components/product/useProductsList'
import CampaignLinkBtn from '@/components/link/CampaignLinkBtn.vue'
import InfluencerLinkBtn from '@/components/link/InfluencerLinkBtn.vue'
import DownloadExcel from '@/components/product/downloadExcel.vue'


export default {
  components: {
    ProductsListFilters,

    BCard,
    BCardTitle,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormCheckbox,
    BTableLite,

    BPopover,
    vSelect,
    CampaignLinkBtn,
    InfluencerLinkBtn,
    DownloadExcel
  },
  data() {
    return {
      excelPopup:false,
      popoverShow: false,
    }
  },
  props: {
    tableColumns: {
      type: Array,
      default: null,
    },
    params: {
      type: Object,
      default: () => ({}) // Boş bir nesne
    },
    title: {
      type: String,
      default: () => 'Ürün Listesi' // Boş bir nesne
    },
    checkPayment: {
      type: Boolean,
      default: () => (false) 
    }
  },
  methods: {
    onClose() {
      alert("başarılı")
      this.popoverShow = false
    },
    onOk() {
      alert("başarılı")
    },
  },
  setup(props, { emit }) {

    const linkStatusOption = [
      {id:'in_link',label:'Link İçi'},
      {id:'out_link',label:'Link Dışı'}
    ]

    const {
      productData,
      tableColumns: defaultTableColumns,
      perPage,
      currentPage,
      totalProducts,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refProductsListTable,

      additionalParams,
      linkFilter

    } = useProductsList();

    additionalParams.value = { ...props.params };
    
    watch(() => props.params, async (newParams) => {
        additionalParams.value = { ...newParams };  
    }, { deep: true });

    watch([productData], () => {
      emit("products-fetched", productData.value);
    })

    const resolvedTableColumns = props.tableColumns || defaultTableColumns;
    
    return {
      productData,
      resolvedTableColumns,
      perPage,
      currentPage,
      totalProducts,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refProductsListTable,
      
      linkStatusOption,
      linkFilter,

      avatarText,

      additionalParams
    }
  },
}
</script>

<style lang="scss">
.selected-row {
  background-color: #d1e7dd !important; /* Açık yeşil arka plan */
}
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
.per-page-selector {
  width: 90px;
}
.fixed-bottom {
  margin-bottom: 4vw; /* Toast'ın alt kısımdaki yüksekliği */
}
.text-center {
  text-align: center; /* Yazıyı ortalamak için */
}
</style>